module.exports = __webpack_public_path__ + "static/img/pin_blue.991b57b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/pin_blue.png
// module id = 721
// module chunks = 6